module.exports = __webpack_public_path__ + "static/media/niu.bd8f0991.svg";